import { motion } from "framer-motion";
import { APPS } from "../data/quiz";

export const AppGrid = ({ selected, onToggle }) => (
  <div data-testid="app-grid" className="grid grid-cols-3 gap-3">
    {APPS.map(({ id, label, Icon, brand }, i) => {
      const active = selected.includes(id);
      return (
        <motion.button
          key={id}
          data-testid={`app-tile-${id}`}
          onClick={() => onToggle(id)}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: i * 0.05 }}
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.94 }}
          className={`relative flex aspect-square flex-col items-center justify-center gap-2 rounded-2xl border p-3 transition-colors ${
            active
              ? "border-limeink bg-lime/25 shadow-[0_6px_20px_rgba(204,255,0,0.45)]"
              : "border-black/10 bg-white shadow-sm hover:border-black/25"
          }`}
        >
          <Icon className="h-7 w-7" style={{ color: brand }} />
          <span
            className={`text-center text-xs font-semibold leading-tight ${
              active ? "text-limeink" : "text-zinc-600"
            }`}
          >
            {label}
          </span>
        </motion.button>
      );
    })}
  </div>
);
